import { isValidElement, type ReactNode } from "react";

import { trimText } from "./utils";

/** Resolve the breadcrumb registry label from an explicit prop or page title children. */
export function resolvePageBreadcrumbLabel(
  breadcrumbLabel: string | undefined,
  children: ReactNode,
): string {
  const explicit = breadcrumbLabel != null ? trimText(breadcrumbLabel) : "";
  if (explicit !== "") {
    return explicit;
  }
  return flattenReactNodeToBreadcrumbLabel(children).trim();
}

function flattenReactNodeToBreadcrumbLabel(node: ReactNode): string {
  if (node == null || typeof node === "boolean") {
    return "";
  }
  if (typeof node === "string" || typeof node === "number") {
    return String(node);
  }
  if (Array.isArray(node)) {
    return node
      .map((child) => flattenReactNodeToBreadcrumbLabel(child))
      .join("");
  }
  if (isValidElement(node)) {
    const child = (node.props as { children?: ReactNode }).children;
    return flattenReactNodeToBreadcrumbLabel(child);
  }
  return "";
}
